import { createAction, props } from '@ngrx/store';

export const setUserListPageNumber = createAction('[User Management] Set User List Page Number', props<{ pageNumberUserList: number }>());
export const setUserListItemsPerPage = createAction('[User Management] Set User List Items Per Page', props<{ itemsPerPageUserList: number }>());